import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[finraRouterOutletAnchor]',
})
export class FinraRouterOutletAnchorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {

  }
}
